export default __webpack_public_path__ + "logo-google-play-fr-c3797578d40da41feaeee953656a0e06.svg";